/**
 * Google Pay configuration and constants
 */

export const GOOGLE_PAY_CONFIG = {
  // express checkout element configuration
  EXPRESS_CHECKOUT_OPTIONS: {
    paymentMethods: {
      googlePay: 'always',
      link: 'never',
      applePay: 'never',
      amazonPay: 'never',
      paypal: 'never',
      klarna: 'never',
    },
    buttonTheme: {
      googlePay: 'black'
    },
    buttonType: {
      googlePay: 'buy'
    },
    layout: {
      overflow: 'never'
    },
    shippingAddressRequired: true,
    billingAddressRequired: true,
    emailRequired: true,
    phoneNumberRequired: true,
    buttonHeight: 55
  }
};

export default GOOGLE_PAY_CONFIG;